String.prototype.separate =
	/**
	 * Separates a string into a series of elements. If the string is of length zero,
	 * an empty array is returned.
	 * @param separator
	 * @param limit
	 * @returns {string[]}
	 */
    function(separator, limit)
	{
		let elements = this.split(separator, limit);
		return (elements.length === 1 && elements[0].length === 0) ? [] : elements;
	};

String.prototype.toFloat =
	function()
	{
		return parseFloat(this);
	};

String.prototype.toInt =
	function()
	{
		return parseInt(this);
	};

String.prototype.splitToFloats =
	function(separator)
	{
		return this.separate(separator || ',').map((element) => element.toFloat());
	};

String.prototype.splitToInts =
	function(separator)
	{
		return this.separate(separator || ',').map((element) => element.toInt());
	};
